import { render } from "./VideoAnimation.vue?vue&type=template&id=9296f1ac&scoped=true"
import script from "./VideoAnimation.vue?vue&type=script&lang=js"
export * from "./VideoAnimation.vue?vue&type=script&lang=js"

import "./VideoAnimation.vue?vue&type=style&index=0&id=9296f1ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9296f1ac"]])

export default __exports__